import React, { useState, useEffect } from 'react';
import { Dialog, Button, Stack, useMediaQuery } from '@material-ui/core';
import ImageCrop from './ImageCrop';
import { useTheme } from '@material-ui/styles';
import PulseLoader from './loaders/PulseLoader';

const UploadImageDialog = ({ open, handleClose, handleUploadImage, loading, src }) => {
  const theme = useTheme();
  const [selectedImage, setSelectedImage] = useState(null);
  const [disableSave, setDisableSave] = useState(true);
  const [width, setWidth] = useState('30vw');
  const [, setHeight] = useState('35vw');

  //if screen < lg then size = 80vw
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  useEffect(() => {
    if (isMd) {
      setWidth('80vw');
      setHeight('85vw');
    } else {
      setWidth('30vw');
      setHeight('35vw');
    }
  }, [isMd]);

  const onCropComplete = (crop) => {
    setSelectedImage(crop);
  };

  const handleDisableSave = (value) => {
    setDisableSave(value);
  };
  return (
    <Dialog maxWidth="lg" open={open} onClose={() => handleClose()}>
      <div style={{ width: width, position: 'relative' }}>
        <ImageCrop src={src} disableSave={handleDisableSave} onCropComplete={onCropComplete} />
      </div>
      <Stack
        direction="row"
        spacing={2}
        justifyContent={'center'}
        alignItems={'center'}
        px={2}
        pb={1}
      >
        <Button
          fullWidth
          onClick={() => handleClose()}
          style={{
            backgroundColor: theme.palette.grey[300],
            color: theme.palette.grey[800],
            width: '100%'
          }}
          size="large"
          disableElevation
        >
          Cancel
        </Button>
        <Button
          fullWidth
          onClick={async () => handleUploadImage(selectedImage)}
          color="incorta"
          variant="contained"
          size="large"
          disabled={disableSave || loading}
        >
          {loading ? <PulseLoader size={10} color="white" /> : 'Save'}
        </Button>
      </Stack>
    </Dialog>
  );
};

export default UploadImageDialog;
